import * as React from 'react';

// tslint:disable:max-line-length
export const GoogleWhite = () => (
  <div
    style={{
      width: 150,
      height: 50,
      background: `url('${require('./medias/google_white.svg')}')`,
      backgroundSize: '100% 100%'
    }}
  />
);



// WEBPACK FOOTER //
// src/app/src/components/Badges/GoogleWhite.tsx